import { useTheme } from 'next-themes';
import logoBlack from '@/assets/autelion-logo-black.png';
import logoWhite from '@/assets/autelion-logo-white.png';

interface AutelionLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10',
  xl: 'h-12',
};

export function AutelionLogo({ size = 'md', className = '' }: AutelionLogoProps) {
  const { theme, systemTheme } = useTheme();
  
  // Determine if we should show dark mode logo
  const isDark = theme === 'dark' || (theme === 'system' && systemTheme === 'dark');
  const logoSrc = isDark ? logoWhite : logoBlack;
  
  return (
    <a 
      href="https://www.autelion.com" 
      target="_blank" 
      rel="noopener noreferrer"
      className="flex-shrink-0"
    >
      <img 
        src={logoSrc} 
        alt="Autelion AB" 
        className={`${sizeClasses[size]} w-auto ${className}`}
      />
    </a>
  );
}
